import { Box, Typography } from '@mui/material'
import { APPEARANCE_MODE_OPTIONS } from '@/components/Settings/appearanceConstants'
import styles from '@/components/Settings/AppearanceSettingsContent.module.scss'

/**
 * @param {{ value: string, onChange: (value: string) => void }} props
 */
export default function AppearanceThemePicker({ value, onChange }) {
  return (
    <Box className={styles.themePicker} role="radiogroup" aria-label="Appearance">
      {APPEARANCE_MODE_OPTIONS.map((mode) => {
        const selected = value === mode.value
        return (
          <button
            key={mode.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`${styles.themeOption}${selected ? ` ${styles.themeOptionSelected}` : ''}`}
            onClick={() => onChange(mode.value)}
          >
            <span
              className={`${styles.themePreview}${mode.value === 'system' ? ` ${styles.themePreviewAuto}` : ''}${mode.value === 'light' ? ` ${styles.themePreviewLight}` : ''}${mode.value === 'dark' ? ` ${styles.themePreviewDark}` : ''}`}
              aria-hidden
            />
            <Typography
              component="span"
              variant="body2"
              className={selected ? styles.themeLabelSelected : styles.themeLabel}
            >
              {mode.label}
            </Typography>
          </button>
        )
      })}
    </Box>
  )
}
